export default __webpack_public_path__ + "static/media/liiv-logo.97a20e70.png";